import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AngularMaterialModule } from '@cradua/material';
import { AppComponent } from './app.component';
import { RouterModule, RouterState } from '@angular/router';
import { EpimsDashboardNavModule } from '@cradua/epims-dashboard-nav';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EpimsReferencesModule } from '@cradua/epims-references';
import { StakeholderreferenceModule } from '@cradua/stakeholderreference';
import { AppRoutingModule } from './app-routing.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { environment } from '../environments/environment';
import { reducers } from './reducers';
import { StakeholderModule } from '@cradua/stakeholder';
import { AnchorepimsgatesModule } from '@cradua/anchorepimsgates';
import { DocumentoperationsModule } from '@cradua/documentoperations';
import { IncidentModule } from '@cradua/incident';
import { GatewayModule } from '@cradua/gateway';
import { CoreModule } from '@cradua/core';
import { AuthFacade, AuthModule } from '@cradua/auth';
import { HomeComponent } from './home/home/home.component';
import { DashboardHomeComponent } from './dashboard/dashboard/dashboard.component';
import { PipelineModule } from '@cradua/pipeline';
import { FormsModule } from '@angular/forms';
import { AcquisitionModule } from '@cradua/acquisition';
import { AudittrayModule } from '@cradua/audittray';
import {StakeholderResponseModule} from '@cradua/stakeholderresponse';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ContractorModule } from '@cradua/contractor';
import { AdrProgressModule } from '@cradua/adr-progress';
import { NgxIndexedDBModule,DBConfig } from 'ngx-indexed-db';
import { NgxChartsModule } from '@swimlane/ngx-charts';


import { dbConfig} from './indexdbconfig';
import { AuthorizedGuard } from 'libs/auth/src/lib/services/auth-guard.service';




const dbConfig2: DBConfig  = {
  name: 'MyDb',
  version: 1,
  objectStoresMeta: [{
    store: 'people',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: [
      { name: 'name', keypath: 'name', options: { unique: false } },
      { name: 'email', keypath: 'email', options: { unique: false } },
      { name: 'batchNo', keypath: 'batchNo', options: { unique: false } },
      { name: 'transdate', keypath: 'transdate', options: { unique: false } },
      { name: 'transtype', keypath: 'transtype', options: { unique: false } }
    ]
  }]
};




@NgModule({
  declarations: [AppComponent,HomeComponent,DashboardHomeComponent],
  imports: [
  NgbModule,
  BrowserModule,
    FormsModule,
    AngularMaterialModule,
    EpimsDashboardNavModule,
    EpimsReferencesModule,
    CoreModule,
    AuthModule,
    Ng2SearchPipeModule,
    // StakeholderreferenceModule,
    // StakeholderModule,
    AnchorepimsgatesModule,
  
    NgxChartsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    GatewayModule,
    ContractorModule,
    // DocumentoperationsModule,
    PipelineModule,
    AdrProgressModule,
    IncidentModule,
    AcquisitionModule,
    AudittrayModule,

    StakeholderResponseModule,
  
    StoreModule.forRoot(reducers, {
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
        strictActionSerializability: false,
        strictStateSerializability: true,
      },
    }),
    EffectsModule.forRoot([]),
    AppRoutingModule,

    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
    }),
    // StoreRouterConnectingModule.forRoot({
    //   routerState: RouterState.Minimal,
    //   // serializer: CustomSerializer,
    // }),
    !environment.production ? StoreDevtoolsModule.instrument() : [],

    NgxIndexedDBModule.forRoot(dbConfig)

  ],
 
  providers: [AuthFacade],
  bootstrap: [AppComponent],
})
export class AppModule {}
